import { z } from "zod";

export const WebVitalNameSchema = z.enum(["LCP", "INP", "CLS", "FCP", "TTFB"]);
export const WebVitalRatingSchema = z.enum(["good", "needs-improvement", "poor"]);

/**
 * ✅ Data Fortress: validação antes de enviar qualquer payload.
 * Observação: value/delta podem vir como números em ms (exceto CLS, que é unitless).
 */
export const WebVitalInsertSchema = z.object({
  user_id: z.string().uuid(),
  path: z.string().min(1).max(500),
  metric_name: WebVitalNameSchema,
  value: z.number().finite().nonnegative(),
  rating: WebVitalRatingSchema,
  delta: z.number().finite().optional(),
  navigation_type: z.string().max(40).optional(),
});

export type WebVitalInsert = z.infer<typeof WebVitalInsertSchema>;
